export default {
      id: "camera_id-usage",
      viewBox: "0 0 22 18",
      url: __webpack_public_path__ + "img/icons.svg#camera_id",
      toString: function () {
        return this.url;
      }
    }